import React from "react";
import bulb from "../assets/bulb.svg";
import cart from "../assets/cart.svg";


function formatGbp(value) {
  const n = Number(value);
  if (!Number.isFinite(n)) return "£0.00";
  return `£${n.toFixed(2)}`;
}

/**
 * Smart Basket promo: centered copy when logged out; full split layout with savings when logged in.
 */
function SmartBasketBanner({
  className = "",
  isLoggedIn,
  onReviewBasket,
  onComparePrices,
  reviewLabel = "Review Basket",
  compareLabel = "Compare Prices",
  showBestOverallBasketFallback = true,
  saveUpToAmount = 6.4,
  vsHighestAmount = 4.2,
  bestBasketStore = "Sainsbury's",
  bestBasketTotal = 28.3,
  savingMessage = "",
  bestOverallBasket = "",
}) {
  const shellClass =
    "relative w-full overflow-hidden bg-gradient-to-b from-[#7352C7] to-[#A67FFB] rounded-xl border border-white/20 shadow-[0_16px_40px_-20px_rgba(123,94,212,0.55)]";

  if (!isLoggedIn) {
    return (
      <div className={`${shellClass} ${className}`}>
        <div className="px-5 py-10 sm:px-8 sm:py-12 md:px-12 md:py-14">
          <div className="mx-auto flex max-w-3xl flex-col items-center justify-center text-center text-white">
            <p className="text-[16px] font-medium text-white sm:text-base">Today&apos;s Smart Basket</p>
            <h2 className="mt-1 text-[28px] font-bold leading-tight tracking-tight sm:text-[28px] md:text-[32px]">
            Save up to {formatGbp(saveUpToAmount)}
            </h2>
            <p className="mt-2 capitalize text-[16px] font-normal text-white sm:text-[15px]">
            Compare your full list across 12 supermarkets and unlock the lowest total for your shop today.
            
            </p>
            <p className="capitalize text-[16px] font-normal text-white sm:text-[15px]">
            We’ve matched your items, applied the best available offers, and calculated the smartest basket for you.
            </p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className={`${shellClass} ${className}`}>
      <div className="flex flex-col gap-8 px-5 py-7 sm:px-7 sm:py-8 lg:flex-row lg:items-stretch lg:gap-10 lg:px-9 lg:py-10">
        <div className="min-w-0 max-w-2xl shrink-0 text-white">
          <p className="text-[16px] font-medium text-white">Today&apos;s Smart Basket</p>
          <h2 className="mt-1 text-[26px] font-bold text-white sm:text-[24px] md:text-[28px]">
            Save up to {formatGbp(saveUpToAmount)}
          </h2>
          <p className="mt-3 text-[16px] capitalize font-normal leading-relaxed tracking-wide text-white sm:text-[16px]">
          Compare your full list across 12 supermarkets and unlock the lowest total for your shop today.
          We’ve matched your items, applied the best available offers, and calculated the smartest basket for you.
          </p>
        </div>

        <div className="flex min-w-0 flex-col items-stretch gap-5 lg:max-w-md lg:items-start lg:text-right">
          <div className="flex flex-col gap-3 text-left text-[#fff] capitalize lg:items-start lg:text-right">
            <p className="flex items-start gap-2 text-[16px] font-medium leading-snug sm:text-[16px] lg:justify-start text-left">
              <img src={bulb} alt="bulb" className="mt-0.5 h-5 w-5 shrink-0 opacity-95" />
              <span>
                {savingMessage
                  ? savingMessage
                  : `You're saving ${formatGbp(vsHighestAmount)} vs the highest-priced basket`}
              </span>
            </p>
            {bestOverallBasket ? (
              <p className="flex items-start gap-2 text-[16px] font-medium leading-snug sm:text-[16px] lg:justify-start">
                <img src={cart} alt="cart" className="mt-0.5 h-5 w-5 shrink-0 opacity-95" />
                <span>{bestOverallBasket}</span>
              </p>
            ) : showBestOverallBasketFallback ? (
              <p className="flex items-start gap-2 text-[16px] font-medium leading-snug sm:text-[16px] lg:justify-start">
                <img src={cart} alt="cart" className="mt-0.5 h-5 w-5 shrink-0 opacity-95" />
                <span>{`Best overall basket: ${bestBasketStore} (${formatGbp(bestBasketTotal)})`}</span>
              </p>
            ) : null}
          </div>

          <div className="flex flex-col gap-3 sm:flex-row sm:flex-wrap lg:justify-start">
            {onReviewBasket ? (
              <button
                type="button"
                onClick={onReviewBasket}
                className="inline-flex items-center shadow-sm justify-center rounded-full border-2 border-white bg-transparent px-6 py-1.5 text-[16px] font-bold text-[#FFFFFF] "
              >
                {reviewLabel}
              </button>
            ) : null}
            {onComparePrices ? (
              <button
                type="button"
                onClick={onComparePrices}
                className="inline-flex items-center justify-center rounded-full bg-white px-6 py-1.5 text-[16px] font-bold text-[#7b5ed4] shadow-sm"
              >
                {compareLabel}
              </button>
            ) : null}
          </div>
        </div>
      </div>
    </div>
  );
}

export default SmartBasketBanner;